import {
  IconButton,
  Paper,
  MenuList,
  MenuItem,
  ClickAwayListener,
  Popper,
} from "@mui/material";
import "./DatePicker.css";

import React, { useState } from "react";
import { DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { SearchOutlined } from "@mui/icons-material";
import dayjs from "dayjs";

const PRESET_LABELS = {
  "5m": "Dernières 5 minutes",
  "15m": "Dernières 15 minutes",
  "30m": "Dernières 30 minutes",
  "1h": "Dernière heure",
  "3h": "3 dernières heures",
  "24h": "24 dernières heures",
};

const ClockIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.5V12l3 2" />
  </svg>
);

const ChevronIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M6 9l6 6 6-6" />
  </svg>
);

const DateCriteria = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [label, setLabel] = useState(PRESET_LABELS["30m"]);

  const pickedDate = (time) => {
    let currentDate = new Date();

    switch (time[time.length - 1]) {
      case "m": {
        let dates = {
          startDate: new Date(
            currentDate.getTime() -
              parseInt(time.substring(0, time.length - 1)) * 60 * 1000
          ),
          endDate: currentDate,
        }
        setLabel(PRESET_LABELS[time]);
        props.pickedDates(dates);
        break;
      }
      case "h": {
        let dates = {
          startDate: new Date(
            currentDate.getTime() -
              parseInt(time.substring(0, time.length - 1)) * 60 * 60 * 1000
          ),
          endDate: currentDate,
        }
        setLabel(PRESET_LABELS[time]);
        props.pickedDates(dates);
        break;
      }
      default:
        break;
    }
    setAnchorEl(false);
  };

  const alterAnchorEl = (e) => {
    if (anchorEl == null) {
      setAnchorEl(e.currentTarget);
    } else {
      setAnchorEl(null);
    }
  };


  const handleClose = () => {
    setAnchorEl(null);
  };

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  /**
   * choose date of date range by field: (startDate, endDate)
   * @param {*} e change event of the picked date
   */
  const chooseDate = (field, e) => {
    if (field === "startDate") {
      if (endDate === null || e.$d < endDate) {
        setStartDate(e);
      } else {
        throw new Error("startDate is not correct, check the end date");
      }
    } else if (field === "endDate") {
      if (startDate === null || e.$d > startDate) {
        setEndDate(e);
      } else {
        throw new Error("endDate is not correct, check the end date");
      }
    }
  };

  const rangeDateSelected = () => {
    props.pickedDates({ startDate: startDate.$d, endDate: endDate.$d });
    setLabel("Plage personnalisée");
    setAnchorEl(false);
  };

  return (
    <div className="date-picker">
      <button
        type="button"
        className="date-picker-trigger"
        onClick={(e) => alterAnchorEl(e)}
        aria-expanded={open ? "true" : undefined}
      >
        <ClockIcon />
        <span>{label}</span>
        <ChevronIcon />
      </button>

      <Popper open={open} anchorEl={anchorEl} placement="bottom-end" className="app-popper">
        <Paper className="date-picker-panel">
          <ClickAwayListener onClickAway={handleClose}>
            <div style={{ padding: "10px" }}>
              <MenuList open={open}   >
                <MenuItem onClick={() => pickedDate("5m")}>Dernières 5 minutes</MenuItem>
                <MenuItem onClick={() => pickedDate("15m")}>
                  Dernières 15 minutes
                </MenuItem>
                <MenuItem onClick={() => pickedDate("30m")}>
                  Dernières 30 minutes
                </MenuItem>
                <MenuItem onClick={() => pickedDate("1h")}>
                  Dernière heure
                </MenuItem>
                <MenuItem onClick={() => pickedDate("3h")}>
                  3 dernières heures
                </MenuItem>
                <MenuItem onClick={() => pickedDate("24h")}>
                  24 dernières heures
                </MenuItem>
              </MenuList>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div
                  className="date-range-picker"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    rowGap: "10px",
                  }}
                >
                  <div>
                    <label>Date précise</label>
                    <IconButton
                      disabled={startDate == null && endDate == null}
                      onClick={rangeDateSelected}
                    >
                      <SearchOutlined />
                    </IconButton>
                  </div>
                  <DateTimePicker
                    localeText={{
                      start: "",
                      end: "",
                    }}
                    maxDateTime={endDate === null ? dayjs() : endDate}
                    value={startDate}
                    onChange={(e) => chooseDate("startDate", e)}
                  />
                  <DateTimePicker
                    localeText={{
                      start: "",
                      end: "",
                    }}
                    minDateTime={startDate}
                    maxDateTime={dayjs()}
                    value={endDate}
                    onChange={(e) => chooseDate("endDate", e)}
                  />
                </div>
              </LocalizationProvider>
            </div>
          </ClickAwayListener>
        </Paper>
      </Popper>
    </div>
  );
};

export default DateCriteria;
